import { isAction, type Middleware } from "@reduxjs/toolkit";
import { invalidateSession } from "~/app/api/pageData";
import { CHANGE_SALES_PARTNER, CLEAR_SALES_PARTNER, UPDATE_SUBSIDIARY } from "~/domains/affiliate/redux/actions";

const sessionChangingAffiliateActions = new Set([CHANGE_SALES_PARTNER, CLEAR_SALES_PARTNER, UPDATE_SUBSIDIARY]);

export const affiliateSessionMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);

  if (isAction(action) && sessionChangingAffiliateActions.has(action.type)) {
    invalidateSession();
  }

  return result;
};
